import React from 'react'
import _ from 'lodash'
import { Link } from 'camino-react'

import { meanTwoDecimalPlaces } from 'Utilities/Math'

const columns = [
  {
    text: 'Client name',
    id: 'clientName',
    accessor: t => t.clientName
  },
  {
    text: 'Tickets',
    id: 'ticket',
    accessor: t => `${t.alert ? '(Alert) ' : ''}${t.title.substring(0, 30)}...`,
    aggregate: vals => vals.length
  },
  {
    text: 'Chargable rate',
    accessor: 'chargeableRate',
    aggregate: vals => meanTwoDecimalPlaces(vals),
    Aggregated: row => (
      <span key={row.value}>
        {`${row.value} (avg)`}
      </span>
    )
  },
  {
    text: 'Chargeable hours',
    accessor: 'chargeableHours',
    aggregate: vals => _.sum(_.map(vals, val => (val === null ? 0 : parseFloat(val)))),
    Aggregated: row => (
      <span key={row.value}>
        {`${row.value} (total)`}
      </span>
    )
  },
  {
    text: 'Link',
    accessor: t => ({ href: t.href, text: `#${t.id}` }),
    id: 'link',
    aggregate: vals => (
      <Link href={vals[0].href}>
        {vals[0].text}
      </Link>
    ),
    Aggregated: row => (<span />)
  },
  {
    text: 'Reviewed at',
    id: 'reviewedAt',
    accessor: t => t.reviewedAt,
    Aggregated: row => (<span />)
  },
  {
    text: 'Reviewed by',
    id: 'reviewedBy',
    accessor: t => t.reviewedBy,
    Aggregated: row => (<span />)
  }
]

export { columns }
